import axios from "axios";
import { base_URL } from "../config/config";
const APIKEY = process.env.REACT_APP_LOCATION_API_KEY;

export const getCoordinatesFromEmbedUrl = async (url) => {
	// const response = await axios.post(`${base_URL}/api/expand-link`, {
	// 	shortLink: url,
	// });
	// const expandedUrl = response?.data?.expandedUrl;

	try {
		url = await validateShortLink(url);
		const address = extractAddressFromEmbedUrl(url);
		const coordinatesResponse = await axios.get(
			`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
				address
			)}&key=${APIKEY}`
		);
		return coordinatesResponse?.data?.results?.[0]?.geometry?.location ?? null;
	} catch (error) {
		return url;
	}
};

const validateShortLink = async (url) => {
	try {
		if (url.includes("https://maps.app.goo.gl/")) {
			const response = await axios.post(`${base_URL}/api/expand-link`, {
				shortLink: url,
			});
			url = response?.data?.expandedUrl;
		}
		return url;
	} catch (error) {
		return url;
	}
};

const extractAddressFromEmbedUrl = (embedUrl) => {
	try {
		const decodedUrl = decodeURIComponent(embedUrl);

		const addressMatch1 = decodedUrl.match(/!2s([^!]+)/);
		if (addressMatch1 && addressMatch1[1]) {
			return addressMatch1[1].replace(/\+/g, " ");
		}

		const addressMatch2 = decodedUrl.match(/place\/([^/]+)/);
		if (addressMatch2 && addressMatch2[1]) {
			return addressMatch2[1].replace(/\+/g, " ").split("@")[0];
		}

		return null;
	} catch (error) {
		return null;
	}
};
